import React, { useContext, useEffect, useState } from 'react';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { BaseURL } from '../../Files/BaseURL';
import AlertContext from '../../Context/Alert/AlertContext';

function CountryRegionSelectorComponent({ Address }) {
  const [country, setCountry] = useState('');
  const [CountryList, setCountryList] = useState([])
  const [region, setRegion] = useState('');

  const {showAlert} = useContext(AlertContext)

  const selectCountry = (val) => {
    setCountry(val);
    setRegion(''); // Reset region when changing country
  };

  const selectRegion = (val) => {
    setRegion(val);
  };


  const fetchCountry = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/auth/getcountry`);
      const data = await response.json();
      setCountryList(data.Country);
    } catch (error) {
      showAlert(error.message, 'danger');
    }
  };

  useEffect(() => {
    fetchCountry()
  }, [])

  return (
    <>

      <CountryDropdown
        value={country}
        showDefaultOption={CountryList}
        onChange={(val) => selectCountry(val)}
        className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
      />

      <div className="flex flex-col md:flex-row mb-3 w-full">

        {country && <div className='mb-3 w-full md:mb-0 md:mr-1'>

          <RegionDropdown
            country={country}
            value={region}
            onChange={(val) => selectRegion(val)}
            className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
          />

        </div>}

        <input
          type="text"
          id="zip"
          placeholder="Zip"
          className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
        />

      </div>
    </>
  );
}

export default CountryRegionSelectorComponent;
